import type { UserRow } from '../userViewModel';

import FhBackfillCard from './FhBackfillCard';

interface InviteLinkTargetCardProps {
  user: UserRow;
  /** Set when the operator picked this target and can back out of it. */
  onClear?: () => void;
}

/** The imported record this invite will bind. */
export default function InviteLinkTargetCard({ user, onClear }: InviteLinkTargetCardProps) {
  return (
    <div>
      <FhBackfillCard user={user} />
      {onClear && (
        <button
          type="button"
          onClick={onClear}
          className="mt-1.5 text-[11.5px] font-semibold text-stone-600 dark:text-stone-400 hover:underline"
        >
          Not this person — invite as someone new
        </button>
      )}
    </div>
  );
}
